import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { StackmapOverlay } from '@bibliocommons/stackmap';
import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';
import { libraryShape, stackMapShape } from '@bibliocommons/bc-prop-types';
import { selectStackMapData, selectStackMapTransactions } from 'app/selectors/StackMapSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import StackMapActions from 'app/actions/StackMapActions';

class StackMapContainer extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const { stackMapTransactions } = this.props;
    const { stackMapTransactions: prevStackMapTransactions } = prevProps;

    if (
      !stackMapTransactions.get('isFetching') &&
      prevStackMapTransactions.get('isFetching') &&
      !stackMapTransactions.get('noResults') &&
      prevStackMapTransactions.get('noResults')
    ) {
      BCGoogleAnalyticsUtils.event(
        {
          eventCategory: 'stack-map',
          eventAction: 'map-found',
          eventLabel: this.props.stackMap.get('callno') || '',
          eventValue: stackMapTransactions.get('noResults') ? 0 : 1
        },
        true
      );
    }
  }

  render() {
    return this.props.stackMapTransactions.get('open') ? <StackmapOverlay {...this.props} /> : null;
  }
}

StackMapContainer.propTypes = {
  currentLibrary: libraryShape.isRequired,
  stackMapActions: PropTypes.objectOf(PropTypes.func).isRequired,
  stackMap: stackMapShape,
  stackMapTransactions: ImmutablePropTypes.mapContains({
    open: PropTypes.bool,
    noResults: PropTypes.bool,
    isFetching: PropTypes.bool
  })
};

const mapStateToProps = state => {
  return {
    stackMap: selectStackMapData(state),
    stackMapTransactions: selectStackMapTransactions(state),
    currentLibrary: selectCurrentLibrary(state)
  };
};

const mapDispatchToProps = dispatch => ({
  stackMapActions: bindActionCreators(StackMapActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(StackMapContainer);
